/*
  Имя файла в журнале шага и под ним - «Скачать · хранится до …» (19.10.2026).

  Решение владельца: файл загрузки хранится 30 дней и скачивается из журнала.
  Строка без хранимого файла (обмен 1С, загрузка до 19.10.2026) показывает одно
  имя; файл, убранный по сроку, - «файл удалён: прошло 30 дней», а не пропавшую
  молча ссылку.

  Отдельным компонентом: журнал (`ImportJournal`) стоит у предела размера.
*/

import { date } from '../../api/format.js'
import DownloadLink from './DownloadLink.jsx'

export default function JournalFile({ run }) {
  return (
    <>
      {run.filename}
      {run.file_deleted ? (
        <div className="journal-file muted">файл удалён: прошло 30 дней хранения</div>
      ) : run.file_id ? (
        <div className="journal-file muted">
          <DownloadLink fileId={run.file_id} filename={run.filename} /> · хранится до{' '}
          {date(run.file_expires_at)}
        </div>
      ) : null}
    </>
  )
}
